import { render, staticRenderFns } from "./RoleMenuModal.vue?vue&type=template&id=18b6532a&"
import script from "./RoleMenuModal.vue?vue&type=script&lang=js&"
export * from "./RoleMenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports